import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5b33cd31")

_pushScopeId("data-v-5b33cd31")
const _hoisted_1 = {
  key: 0,
  class: "hotspot-module-container"
}
const _hoisted_2 = { class: "top-wrapper" }
const _hoisted_3 = { class: "intro-wrapper" }
const _hoisted_4 = { class: "intro" }
const _hoisted_5 = {
  key: 0,
  class: "spokesperson-wrapper"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "spokesperson-title" }, [
  /*#__PURE__*/_createVNode("span", null, "历史代言人")
], -1)
const _hoisted_7 = { class: "item-intro" }
const _hoisted_8 = { class: "item-name" }
const _hoisted_9 = { class: "item-time" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "代言时间：", -1)
const _hoisted_11 = { class: "item-desc" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ImgContainer = _resolveComponent("ImgContainer")

  return (_ctx.modules)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_ImgContainer, {
            class: "image",
            src: _ctx.modules.top.img
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.top.intro, (i, k) => {
                return (_openBlock(), _createBlock("p", { key: k }, _toDisplayString(i), 1))
              }), 128))
            ]),
            _createVNode("video", {
              src: _ctx.modules.top.video,
              poster: _ctx.modules.top.poster,
              class: "video-wrapper",
              controls: "controls",
              preload: "auto",
              "x5-playsinline": "true",
              playsinline: "true",
              "webkit-playsinline": "true",
              onPlay: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleVideoPlay && _ctx.handleVideoPlay(...args)))
            }, null, 40, ["src", "poster"])
          ])
        ]),
        (_ctx.modules.spokespersonList && _ctx.modules.spokespersonList.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _hoisted_6,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.spokespersonList, (i, k) => {
                return (_openBlock(), _createBlock("div", {
                  class: "spokesperson-item",
                  key: k
                }, [
                  _createVNode(_component_ImgContainer, {
                    class: "item-image",
                    src: i.img
                  }, null, 8, ["src"]),
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, [
                      _createVNode("span", null, _toDisplayString(i.tab), 1),
                      _createVNode("span", null, _toDisplayString(i.name), 1)
                    ]),
                    _createVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode("span", null, _toDisplayString(i.time), 1)
                    ]),
                    _createVNode("div", _hoisted_11, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(i.intro, (m, n) => {
                        return (_openBlock(), _createBlock("p", { key: n }, _toDisplayString(m), 1))
                      }), 128))
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})